import { render, staticRenderFns } from "./KartaNastavenia.vue?vue&type=template&id=12ae70a6&scoped=true&"
import script from "./KartaNastavenia.vue?vue&type=script&lang=js&"
export * from "./KartaNastavenia.vue?vue&type=script&lang=js&"
import style0 from "./KartaNastavenia.vue?vue&type=style&index=0&id=12ae70a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae70a6",
  null
  
)

export default component.exports